import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TopCard } from '../../constants/patient-curves.constants';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  selector: 'aux-ag-patient-driver-top-card',
  styles: [],
  templateUrl: './ag-patient-driver-top-card.component.html',
})
export class AgPatientDriverTopCardComponent {
  @Input() card: TopCard | undefined;
}
